/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type ProgramID = (typeof ProgramID)[keyof typeof ProgramID];

export const ProgramID = {
  access_eckm: "access_eckm",
  access_ckm: "access_ckm",
  access_behavioral_health: "access_behavioral_health",
} as const;
